<template>
  <div>
    <HeaderKuesioner />
    <section class="service-wrapper py-5">
      <div class="container">
        <div class="bg-line"></div>
        <div class="row mt-5">
          <div class="col-12 border-bottom px-4 py-2">
            <div class="row d-flex justify-content-center">
              <div class="col-md-12">
                <survey :survey="survey" class="px-4"></survey>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import HeaderKuesioner from "@/components/hero/HeaderKuesioner.vue";
import * as SurveyVue from "survey-vue";
// import "bootstrap/dist/css/bootstrap.css";
var Survey = SurveyVue.Survey;
Survey.cssType = "bootstrap";


import * as widgets from "surveyjs-widgets";
import { init as customWidget } from "@/components/customwidget";
import SurveyService from '@/services/survey.service';

// widgets.icheck(SurveyVue);
widgets.select2(SurveyVue);
widgets.inputmask(SurveyVue);
widgets.jquerybarrating(SurveyVue);
widgets.jqueryuidatepicker(SurveyVue);
widgets.nouislider(SurveyVue);
widgets.select2tagbox(SurveyVue);
widgets.sortablejs(SurveyVue);
widgets.ckeditor(SurveyVue);
widgets.autocomplete(SurveyVue);
widgets.bootstrapslider(SurveyVue);
customWidget(SurveyVue);

SurveyVue.Serializer.addProperty("question", "tag:number");

import { json } from "@/models/question";

export default {
  components: {
      Survey,
      HeaderKuesioner
    },
    data() {
      return {
        survey: {},
        id: this.$route.params.id_survey,
        id_alumni: this.$route.params.id_alumni
      };
    },

    mounted() {
      this.survey = new SurveyVue.Model(this.$store.state.survey.survey.elements);

      this.survey.onComplete.add(survey => {
      let data = {
        alumni: {
          id_profil: this.id_alumni
        },
        elements: survey.data
      };
        SurveyService.surveyResults(this.id, {data}).then(res => {
          console.log(res);
        }).catch(error => console.error(error));
      })
    },
  };

</script>

<style scoped>
/* @import url('https://fonts.cdnfonts.com/css/glegoo'); */

.sv_main {
    font-family: 'Glegoo', sans-serif;
    font-size: 0.8rem;
    line-height: normal;
}

.sv_main .sv_container .sv_body .sv_p_root .sv_page_title {
    font-size: 2em;
}

.sv_main .sv_container .sv_body .sv_next_btn {
  border-radius: 5px;
  background-color: #8f1212;
  color: #fff;
  padding: 10px 28px !important;
  width: 120px !important;
  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2), 0 6px 20px 0 rgba(0,0,0,0.19);
}

.container {
  margin: 20px auto;
  padding: 0;
  background-color: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 6px 10px 23px -4px rgba(0, 0, 0, 0.75);
  -webkit-box-shadow: 6px 10px 23px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 6px 10px 23px -4px rgba(0, 0, 0, 0.75);
}

.bg-line {
    background-color: #003E29;
    height: 10px;
    margin-bottom: 20px
}

.forms-inputs {
  position: relative;
}

.forms-inputs span {
  position: absolute;
  top: -18px;
  left: 30px;
  background-color: #fff;
  padding: 5px 10px;
  font-size: 15px;
}

.forms-inputs input {
  height: 50px;
  border: 2px solid #eee;
}

.forms-inputs input:focus {
  box-shadow: none;
  outline: none;
  border: 2px solid #010d4a;
}

.btn {
  height: 50px;
}

.success-data {
  display: flex;
  flex-direction: column;
}

.bxs-badge-check {
  font-size: 90px;
}

@media only screen and (max-width: 480px) {
  .forms-inputs input {
    height: 70px;
    font-size: 0.7rem;
  }

  .forms-inputs select {
    height: 70px;
    font-size: 0.7rem;
  }

  .forms-inputs span {
    font-size: 0.8rem;
  }
  .sv_main {
    font-size: 0.4rem;
}
}

</style>
